import { NavLink } from 'react-router-dom';
import { Button, Form } from 'semantic-ui-react';
import styled from 'styled-components';

interface Props {
  firstColor: string
}

const DairyProfileCard = styled.div`
  background: #ffffff;
  box-shadow: 0px 3px 20px #0000000b;
  border-color: transparent;
  border-radius: 0.375rem;
  margin-top: 1.25rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-top: 1.25rem;
  position: relative;
`;

const DairyProfileCardBody = styled.div`
  margin-left: -1.25rem;
  margin-right: -1.25rem;
  display: flex;
  border-bottom-width: 1px;
  border-color: rgba(226 232 240 / 0.6);
  padding-bottom: 1.25rem;
  flex-direction: row;
`;

const DiaryProfileCardFooter = styled.div`
  display: flex;
  width: 100%;
  text-align: center;
  flex-direction: row;
  justify-content: flex-start;

  .ui.secondary.pointing.menu {
    border: none !important;
  }
  .ui.secondary.pointing.menu .active.item {
    border-width: 3px !important;
    border-color: #193175;
  }
`;

const DairyProfileLogo = styled.div`
  display: flex;
  flex: 1 1 0%;
  align-items: center;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  justify-content: flex-start;

  .dairy-logo-container {
    position: relative;
    flex: none;
    height: 8rem;
    width: 8rem;
  > span {
    position: absolute;
      height: 100%;
      width: 100%;
      -o-object-fit: contain;
      object-fit: contain;
      border-radius: 9999px;
      background: #f5f5f5;
      > img {
        position: absolute;
        height: 100%;
        width: 100%;
        -o-object-fit: contain;
        object-fit: contain;
        border-radius: 9999px;
        background: #f5f5f5;
      }
  }
    
  }

  .dairy-name-container {
    margin-left: 1.25rem;

    .dairy-name {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
      font-size: 18px !important;
      line-height: 1.75rem;
      font-weight: 500;
    }

    .dairy-label {
      color: rgb(100 116 139);
    }
  }
`;

const DairyDetails = styled.div`
  flex: 1 1 0%;
  border-right-width: 1px;
  border-left-width: 1px;
  border-color: rgba(226 232 240 / 0.6);
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  margin-top: 0px;
  border-top-width: 0px;
  padding-top: 0px;

  .dairy-details-title {
    font-weight: 500;
    margin-top: 0.75rem;
    text-align: left;
  }

  .dairy-details-body {
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    .dairy-details-row {
      display: flex;
      align-items: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;

      &.mt-3 {
        margin-top: 0.75rem;
      }

      .dairy-details-row-icon {
        margin-right: 0.5rem;
      }
    }
  }
`;

const DairyDetailsCounter = styled.div<Props>`
  display: flex;
  flex: 1 1 0%;
  flex-wrap: wrap;
  align-items: center;
  justify-content: end;
  position: relative;
  border-color: rgba(226 232 240 / 0.6);
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  margin-top: 0px;
  margin-right: 10px;
  position: relative;
  padding-top: 0px;
  color: ${props => props.firstColor};
  .dairy-details-counter-column {
    > i {
      cursor: default !important;
    }
    width: 8rem;
    border-radius: 0.375rem;
    position: relative;
    text-align: center;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    cursor: default !important;
    .font-size-4 {
      margin-right: 0 !important;
    }

    .value {
      font-size: 1.25rem;
      line-height: 1.75rem;
      font-size: 15px !important;
      font-weight: 600;
      color: ${props => props.firstColor};
    }

    .label {
      font-weight: bold;
      color: ${props => props.firstColor};
    }
  }
`;

const DairyTabItem = styled(NavLink)`
  padding: 1.3rem 1.5rem !important;
`;

const BoxHeader = styled.div`
  align-items: center;
  display: flex;
`;
const BoxHeaderTitle = styled.div`
  margin-right: auto;
  font-size: 18px !important;
  font-weight: bold;
`;
const BoxHeaderActions = styled.div`
  margin-left: 0.75rem;
  position: relative;
`;
const BoxHeaderActionsAdd = styled(Button)`
  color: #1e293b !important;
  font-size: 0.975rem !important;
  padding: 0.8rem 1rem !important;
  border: 1px solid rgb(226 232 240) !important;
  background-color: transparent !important;
  box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgb(0 0 0 / 0.05) !important;
  color: rgb(100 116 139) !important;

  > .plus {
    font-size: 1.1rem !important;
    padding-right: 1.6rem !important;
  }
`;

const DrawerFooter = styled(Form.Field)`
  margin-top: 3rem !important;
`;

const StateBox = styled.div`
  box-shadow: 0px 3px 20px #0000000b;
  position: relative;
  border-radius: 0.375rem;
  border-color: transparent;
  margin-bottom: 1rem;
  padding: 1rem;
  background-color: #ffffff;

  .state-box-header {
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
  }

  .state-logo {
    position: relative;
    width: 3rem;
    height: 3rem;
    flex: none;
    overflow: hidden;
    border-radius: 0.375rem;
    align-items: center;
    justify-content: center;
    text-align: center;
    display: flex;
    background: #e5e7eb;
    font-weight: bold;
  }

  .state-content {
    margin-right: auto;
    margin-left: 1rem;

    .state-name {
      font-weight: 600;
    }
  }

  .state-districts-counter {
    cursor: pointer;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    font-size: 0.75rem;
    line-height: 1rem;
    font-weight: 600;
    color: #ffffff;
    border-radius: 9999px;
    background: rgb(13 148 136);
  }

  .state-options {
    margin-left: 2rem;
  }
`;

export const StateEl = {
  DrawerFooter,
  StateBox
};

export const El = {
  DairyProfileCard,
  DairyProfileCardBody,
  DiaryProfileCardFooter,
  DairyProfileLogo,
  DairyDetails,
  DairyDetailsCounter,
  DairyTabItem,
  BoxHeader,
  BoxHeaderActions,
  BoxHeaderTitle,
  BoxHeaderActionsAdd
};
